import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventType, AnalyticEventCategory, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {UIImagePathController} from '../../UIEnums.ts'
import {ViewPopupOptions} from '../../ui_popup/ViewPopupOptions'
import {CA} from '../../analytics/Analytics'
import {ClientUserState} from '../../ClientUserState'
import {KeyBindController, ShortcutLocation} from '../../KeyBindController'
import {ViewPopup} from '../../ui_popup/ViewPopup'
import {createDivIn, createImgIn} from '../../ui_utils/DomUtils'
import {UIGameHelpButtonsController} from './UIGameHelpButtonsController'
import {UIGameHelpButton} from './UIGameHelpButton'
import {navigateToPage} from '../../ui_utils/ClientUtils.ts'

export class UIGameFullScreenButton extends UIGameHelpButton {
    private fullScreenPopup: ViewPopup

    constructor(uiGameHelpButtonController: UIGameHelpButtonsController, parent: HTMLDivElement) {
        super(uiGameHelpButtonController, parent, 'fullscreen_button', LobbyImage.FullScreenExpand)
        this.createFullScreenKeyBoardShortcut()
    }

    private createFullScreenKeyBoardShortcut() {
        KeyBindController.bindKey('KeyF', () => this.onFullScreenTriggered(), () => true, ShortcutLocation.InGame)
    }

    private onFullScreenTriggered() {
        UIGameFullScreenButton.sendFullScreenAnalyticEvent()

        const isMember = ClientUserState.userState?.items.hasMembership()
        if(!isMember) {
            const showNewPopup = this.fullScreenPopup == undefined || this.fullScreenPopup.isRemoved()
            showNewPopup ? this.createFullScreenMembershipPopup() : this.fullScreenPopup.removePopup()
            return
        }
        if(document.fullscreenElement) {
            void this.closeFullScreen()
            return
        }
        void this.openFullScreen()
    }

    private static sendFullScreenAnalyticEvent() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.PopupMembershipIncentiveFullScreen,
        }
        void CA.sendAnalyticEvent(eventData)
    }

    private async closeFullScreen() {
        await document.exitFullscreen()
        this.swapImage(UIImagePathController.getImgPath(LobbyImage.FullScreenExpand))
        this.uiGameManager.canvasController.responsiveController.resizeScreen()
    }

    private async openFullScreen() {
        await document.documentElement.requestFullscreen()
        this.swapImage(UIImagePathController.getImgPath(LobbyImage.FullScreenContract))
        this.uiGameManager.canvasController.responsiveController.resizeScreen()
    }

    private createFullScreenMembershipPopup() {
        const fullScreenPopupBody: TranslationObject = {key: 'strings:game.fullScreen.body'}
        const fullScreenPopupTitle: TranslationObject = {key: 'strings:game.fullScreen.title'}
        const fullScreenPopupOptions: ViewPopupOptions = {
            showCheckButton: true,
            showXButton: false,
            checkButtonCustomContent: {key: 'strings:game.fullScreen.checkButton'},
        }
        this.fullScreenPopup = new ViewPopup(fullScreenPopupTitle, fullScreenPopupBody, () => navigateToPage('/store#membership', true), () => undefined, true, fullScreenPopupOptions)
        const fullscreenImgContainer = createDivIn(this.fullScreenPopup.body, 'popup_fullscreen_img_container')
        const img = createImgIn(fullscreenImgContainer, LobbyImage.FullScreenGif, 'popup_fullscreen_img')

        this.fullScreenPopup.body.style.flexDirection = 'column'
        this.fullScreenPopup.body.style.alignItems = 'center'
        this.fullScreenPopup.checkButton.classList.remove('btn_general')
        this.fullScreenPopup.checkButton.classList.add('popup_adblock_cta_btn')
        this.fullScreenPopup.show()
    }

    clicked(event: PointerEvent) {
        super.clicked(event)
        void this.onFullScreenTriggered()
    }
}
